<template>
    <div>
        <navigation-bar Close/>
        <div class="qr-code main">
            <div class="edit-block">
                <border-input labelText="姓氏">
                    <OpenEyes :value="form.lastName" slot="input" :placeholder="' '" :name="'lastName'"
                              :type="'chinese'" :maxlength="20" @onChange="valueChange"/>
                </border-input>
                <border-input labelText="名字">
                    <OpenEyes :value="form.firstName" slot="input" :placeholder="' '" :name="'firstName'"
                              :type="'chinese'" :maxlength="20" @onChange="valueChange"/>
                </border-input>
                <border-input labelText="公司">
                    <input slot="input" type="text" v-model="form.company"
                           maxlength="20">
                </border-input>
                <border-input labelText="生日" noBorder>
                    <OpenEyes :value="form.birth" slot="input"/>
                    <el-switch
                            slot="right-icon"
                            v-model="form.showBirth"
                            class="lg">
                    </el-switch>
                </border-input>
                <border-input labelText="新增電話" noInput>
                    <el-button slot="icon" icon="el-icon-plus" class="add" circle @click="addItem('phone')"></el-button>
                    <add-line
                            v-for="(item, index) in form.phone"
                            :key="`phone-${index}`"
                            @deleteItem="(index) => deleteItem('phone', index)"
                            :itemIndex="index">
                        <input slot="left" type="text" placeholder="行動電話" v-model="item.key" maxlength="20">
                        <input slot="right" type="tel" placeholder="電話" v-model="item.value"
                               autocorrect="off"
                               autocomplete="off"
                               maxlength="20">
                    </add-line>
                </border-input>
                <border-input labelText="新增電子郵件" noInput>
                    <el-button slot="icon" icon="el-icon-plus" class="add" circle @click="addItem('email')"></el-button>
                    <add-line
                            v-for="(item, index) in form.email"
                            :key="`email-${index}`"
                            @deleteItem="(index) => deleteItem('email', index)"
                            :itemIndex="index">
                        <input slot="left" type="text" placeholder="公司" v-model="item.key" maxlength="20">
                        <input slot="right" type="email" placeholder="電子郵件" v-model="item.value" :class="required(formType.EMAIL, item.value)"
                               maxlength="70"
                               autocorrect="off"
                               autocomplete="off">
                        <span class="hint" slot="right" style="top: 30px">請輸入正確的電子郵件</span>
                    </add-line>
                </border-input>
                <border-input labelText="新增地址" noInput>
                    <el-button slot="icon" icon="el-icon-plus" class="add" circle @click="addItem('address')"></el-button>
                    <add-line
                            v-for="(item, index) in form.address"
                            :key="`address-${index}`"
                            @deleteItem="(index) => deleteItem('address', index)"
                            :itemIndex="index"
                            flexStart>
                        <input slot="left" type="text" placeholder="住家" v-model="item.key">
                        <div slot="right">
                            <input disabled="value" type="text" placeholder="台灣" v-model="item.country">
                            <input type="text" placeholder="郵遞區號│縣市" v-model="item.city" :class="required(formType.CITY, item.city)"
                                   autocorrect="off"
                                   autocomplete="off"
                                   maxlength="250">
                            <span class="hint">請輸入正確的郵遞區號│縣市</span>
                            <input type="text" placeholder="鄉鎮市區" v-model="item.town" :class="required(formType.TOWN, item.town)"
                                   autocorrect="off"
                                   autocomplete="off"
                                   maxlength="250">
                            <span class="hint">請輸入正確的鄉鎮市區</span>
                            <input type="text" placeholder="街名" v-model="item.road" :class="required(formType.ROAD, item.road)"
                                   autocorrect="off"
                                   autocomplete="off"
                                   maxlength="250">
                            <span class="hint">請輸入正確的街名</span>
                        </div>
                    </add-line>
                </border-input>
                <border-input labelText="新增URL" noInput>
                    <el-button slot="icon" icon="el-icon-plus" class="add" circle @click="addItem('url')"></el-button>
                    <add-line
                            v-for="(item, index) in form.url"
                            :key="`url-${index}`"
                            @deleteItem="(index) => deleteItem('url', index)"
                            :itemIndex="index">
                        <input slot="left" type="text" placeholder="首頁" v-model="item.key" maxlength="20">
                        <input slot="right" type="url" placeholder="URL" v-model="item.value"
                               autocorrect="off"
                               autocomplete="off"
                               maxlength="70">
                    </add-line>
                </border-input>
                <!-- 非標準欄位，先隱藏 -->
                <border-input v-if="false" labelText="新增社群網站個人檔案" noInput>
                    <el-button slot="icon" icon="el-icon-plus" class="add" circle @click="addItem('socialUrl')"></el-button>
                    <add-line
                            v-for="(item, index) in form.socialUrl"
                            :key="`socialUrl-${index}`"
                            @deleteItem="(index) => deleteItem('socialUrl', index)"
                            :itemIndex="index">
                        <input slot="left" type="text" placeholder="Twitter" v-model="item.key">
                        <input slot="right" type="text" placeholder="社群網站個人檔案" v-model="item.value">
                    </add-line>
                </border-input>
                <!-- 非標準欄位，先隱藏 -->
                <border-input v-if="false" labelText="新增即時訊息名稱" noInput>
                    <el-button slot="icon" icon="el-icon-plus" class="add" circle
                               @click="addItem('socialName')"></el-button>
                    <add-line
                            v-for="(item, index) in form.socialName"
                            :key="`socialName-${index}`"
                            @deleteItem="(index) => deleteItem('socialName', index)">
                        <input slot="left" type="text" placeholder="Line" v-model="item.key">
                        <input slot="right" type="text" placeholder="即時訊息名稱" v-model="item.value">
                    </add-line>
                </border-input>
                <border-input labelText="備註">
                    <input slot="input" placeholder="請輸入備註" type="text" v-model="form.note" :class="required(formType.NOTE, form.note)" maxlength="250">
                    <span class="hint" slot="input">不得含有&lt;&gt;/;*\等特殊字元或是連續的點(.)</span>
                </border-input>

                <div class="footer-button">
                    <el-button @click.native="cancel" round>取消</el-button>
                    <el-button @click.native="save" type="primary" round>儲存</el-button>
                </div>
            </div>

            <comm-dialog :value="dialog.isShowDialog"
                         :outerContent="dialog.dialogMsg"
                         :isCancel="dialog.cancelable"
                         @result="onCommDialogClose"/>
            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
            <toast/>
        </div>
    </div>

</template>

<script>
    import BorderInput from '@/components/BorderInput.vue'
    import AddLine from '@/views/more/qrCode/components/addLine.vue'
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import CommDialog from "@/components/CommDialog";
    import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";
    import {checkAddress, checkDoubleDots, checkSpecialChars, checkValidEmail} from "@/util/validators";
    import OpenEyes from "@/components/OpenEyes";

    export default {
        name: "Edit",
        components: {CommDialog, BorderInput, AddLine, Toast , OpenEyes},
        data() {
            return {
                form: {
                    lastName: '',
                    firstName: '',
                    company: '',
                    birth: '1990-01-01',
                    phone: [],
                    email: [],
                    address: [],
                    url: [],
                    socialUrl: [],
                    socialName: [],
                    showBirth: false,
                    note: ''
                },
                template: {
                    key: '',
                    value: ''
                },
                addressTemplate: {
                    key: '',
                    country: '台灣',
                    city: '',
                    town: '',
                    road: ''
                },
                isLoading: false,
                //dialog 用
                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                },
                formType: {
                    NICKNAME: 0, EMAIL: 1, CITY: 2, TOWN: 3, ROAD: 4, NOTE: 5
                },
                //檢查欄位時的css用途
                hasCheck: false,
            }
        },
        created() {
            this.getContactInfo()
        },
        mounted() {

        },
        computed:{
            required(){
                return (type, val) => {
                    switch (type) {
                        case this.formType.EMAIL:
                            if (val === '') {
                                return '';
                            } else if (!checkValidEmail(val)) {
                                return 'required';
                            } else {
                                return '';
                            }
                        case this.formType.CITY:
                            if (val === '') {
                                return '';
                            } else if (!checkAddress(val)) {
                                return 'required';
                            } else {
                                return '';
                            }
                        case this.formType.TOWN:
                            if (val === '') {
                                return '';
                            } else if (!checkAddress(val)) {
                                return 'required';
                            } else {
                                return '';
                            }
                        case this.formType.ROAD:
                            if (val === '') {
                                return '';
                            } else if (!checkAddress(val)) {
                                return 'required';
                            } else {
                                return '';
                            }
                        case this.formType.NOTE:
                            if (val === '') {
                                return '';
                            } else if (checkSpecialChars(val) || checkDoubleDots(val)) {
                                return 'required';
                            } else {
                                return '';
                            }
                    }
                }
            },
        },
        methods: {
            /** 顯示訊息 dialog */
            showDialog: function (msg, cancelable = false) {
                this.dialog.cancelable = cancelable;
                this.dialog.dialogMsg = msg;
                this.dialog.isShowDialog = true;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.dialog.isShowDialog = false;
                this.$router.go(-1);
            },

            addItem: function (type) {
                let template = {
                    key: '',
                    value: ''
                }
                switch (type) {
                    case 'phone':
                        template.key = '行動電話'
                        this.form.phone.push(template)
                        break
                    case 'email':
                        template.key = '信箱'
                        this.form.email.push(template)
                        break
                    case 'url':
                        template.key = '首頁'
                        this.form.url.push(template)
                        break
                    case 'address':
                        var addressTemplate = {
                            key: '住家',
                            country: '台灣',
                            city: '',
                            town: '',
                            road: ''
                        }
                        this.form.address.push(addressTemplate)
                        break
                    case 'socialUrl':
                        template.key = 'Twitter'
                        this.form.socialUrl.push(template)
                        break
                    case 'socialName':
                        template.key = 'Line'
                        this.form.socialName.push(template)
                        break
                }
            },
            deleteItem: function (type, index) {
                this.form[type].splice(index, 1)
            },
            getContactInfo: function () {
                this.$http.fetchWithAuth`GetUserContact${{}}
                ${json => {
                    if (json.status) {
                        this.form.firstName = json.data.firstName
                        this.form.lastName = json.data.lastName

                        //空的就帶註冊的姓名
                        let name = json.data.firstName + json.data.lastName;
                        if (name === undefined || name === '') {
                            // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                            const userData = getCryptoUserInfo();
                            this.form.firstName = userData.nickName;
                        }

                        this.form.company = json.data.company
                        this.form.birth = json.data.birthday
                        this.form.showBirth = json.data.isShowBirthday !== 0;

                        let hasTel = false; //是否有電話資料？
                        json.data.contactList.forEach(function (item) {
                            let template = {
                                key: '',
                                value: item.content
                            }
                            switch (item.type) {
                                case 0:
                                    this.form.note = item.content;
                                    break;
                                case 1:
                                    template.key = item.title;
                                    this.form.phone.push(template);
                                    hasTel = true;
                                    break;
                                case 2:
                                    template.key = item.title;
                                    this.form.email.push(template);
                                    break;
                                case 3:
                                    template.key = item.title;
                                    this.form.url.push(template);
                                    break;
                                case 4: {
                                    let addressTemplate = {
                                        key: item.title,
                                        country: '台灣',
                                        city: item.city,
                                        town: item.township,
                                        road: item.address
                                    };
                                    this.form.address.push(addressTemplate);
                                    break;
                                }
                                case 5:
                                    template.key = item.title;
                                    this.form.socialUrl.push(template);
                                    break;
                                case 6:
                                    template.key = item.title;
                                    this.form.socialName.push(template);
                                    break;
                            }
                        }, this);

                        //電話爲空的話就帶註冊時的電話
                        if (!hasTel) {
                            // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                            const userData = getCryptoUserInfo();
                            let template = {
                                key: 'voice',
                                value: userData.phone
                            }
                            this.form.phone.push(template);
                        }
                    }
                }}`;
            },
            information: function () {
                var array = []
                const items = [
                    {typeIndex: 1, type: 'phone'},
                    {typeIndex: 2, type: 'email'},
                    {typeIndex: 3, type: 'url'},
                    {typeIndex: 4, type: 'address'},
                    // {typeIndex: 5, type: 'socialUrl'},
                    // {typeIndex: 6, type: 'socialName'},
                ]
                items.forEach(function (item) {
                    if (item.type === 'address') {
                        this.form[item.type].forEach(function (obj) {
                            if (obj.city !== undefined || obj.town !== undefined || obj.road !== undefined) {
                                array.push({
                                    type: item.typeIndex,
                                    title: obj.key,
                                    content: '',
                                    country: obj.country,
                                    city: obj.city,
                                    township: obj.town,
                                    address: obj.road,
                                    postalCode: ''
                                })
                            }
                        })
                    } else {
                        this.form[item.type].forEach(function (obj) {
                            if (obj.value !== undefined) {
                                array.push({
                                    type: item.typeIndex,
                                    title: obj.key,
                                    content: obj.value,
                                    country: '',
                                    city: '',
                                    township: '',
                                    address: '',
                                    postalCode: ''
                                })
                            }
                        })
                    }
                }, this)
                if (this.form.note !== undefined && this.form.note !== '') {
                    array.push({
                        type: 0,
                        title: '',
                        content: this.form.note,
                        country: '',
                        city: '',
                        township: '',
                        address: '',
                        postalCode: ''
                    })
                }
                return array
            },
            save: function () {
                //必填或錯誤提示紅匡
                this.hasCheck = true;
                if(this.hasCheck === true){
                    //按下按鈕後必填欄位加上紅匡線樣式＆提示字
                    this.$el.style.setProperty('--borderColor333', `${"#EA4E5E"}`)
                    this.$el.style.setProperty('--hintDisplay', `${"block"}`)
                }
                //有錯誤時class為required，當required數量不為0提醒檢查欄位
                const required=document.getElementsByClassName('required').length
                if (required !== 0) {
                    return this.$public.showNotify("有欄位錯誤或未填寫請檢查", false);
                }
                this.isLoading = true;
                this.$http.fetchWithAuth`SaveUserContact${{
                    lastName: this.form.lastName,
                    firstName: this.form.firstName,
                    company: this.form.company,
                    isShowBirthday: this.form.showBirth ? 1 : 0,
                    information: this.information()
                }}
                ${json => {
                    this.isLoading = false;
                    if (json.status) {
                        // this.$store.commit(mutationTypes.SHOW_TOAST, json.message);
                        this.showDialog(json.message);

                        //this.$router.push({name: 'QrCode'})
                    }
                }}`;
            },
            cancel: function () {
                this.$router.go(-1)
            },
            valueChange(name,val){
                if (name==='lastName'){
                    this.form.lastName =val
                }
                else if(name==='firstName'){
                    this.form.firstName =val
                }
            },
        }
    }
</script>
<style lang="less" scoped src="../../../less/personalInfo.less"/>
<style lang="less" scoped>
    /deep/.el-col{
        position: relative;
    }
    .hint{
        position: absolute;
        left: 0;
        //mt
        white-space:nowrap;
    }
</style>